export const signInRoutes = {
  phone: 'phone',
  email: 'email',
  accountNumber: 'account-number'
}
